import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseInputEditor } from './base-editor';
import { CELL_EDITOR_STYLES } from './cell-editor.styles';

@Component({
  selector: 'ct-phone-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [CELL_EDITOR_STYLES],
  template: `
    <input #editInput type="tel" class="cell-input"
      [(ngModel)]="editingValue"
      (keydown)="onKeydown($event)"
      (input)="onInput()"
      placeholder="(000) 000-0000"
      maxlength="20"
      [attr.aria-label]="'Editing ' + column.label"
      [attr.aria-describedby]="ariaDescribedBy"
      [attr.aria-invalid]="hasError || null"
      [attr.aria-required]="isRequired || null" />
  `,
})
export class PhoneEditorComponent extends BaseInputEditor {
  onInput(): void {
    const el = this.editInput?.nativeElement;
    if (!el) return;
    const pos = el.selectionStart;
    el.value = el.value.replace(/[^\d+\-() .]/g, ''); // NOSONAR - replaceAll needs es2021
    this.editingValue = el.value;
    if (pos != null) el.setSelectionRange(pos, pos);
  }
}
